<template>
  <v-card class="notification" :style="`border-color: ${message.color}`">
    <div class="close-icon" v-show="!showStoreName">
      <v-spacer></v-spacer>
      <v-icon size="18" color="error" @click.stop="closeNotify(message)"
        >flaticon-error</v-icon
      >
    </div>
    <v-card-title class="title white--text px-2 py-1" :class="message.color" v-show="showStoreName">
      <span class="body-1 font-weight-bold">
        {{message.store_name || 'ABCDEF'}}
      </span>
      <v-spacer></v-spacer>
      <v-icon size="18" color="white" @click.stop="closeNotify(message)"
        >flaticon-error</v-icon
      >
    </v-card-title>
    <v-card-text>
      <v-layout row wrap>
        <v-flex xs12>
          <div class="subheading" style="display: flex">
            <v-icon left :color="message.color">{{ message.icon }}</v-icon>

            <strong>{{ message.title }}</strong>

            <span class="pl-2 caption">#{{ message.token_no }}</span>
          </div>

          <span class="caption" v-html="message.message"></span><br />

          <v-layout row wrap class="caption mt-2">
            <template v-for="(item, idx) in message.items">
              <v-flex xs10 :key="`${idx}:name`">
                {{ item.menu_name }}
                <div class="pl-1 pink--text" v-for="modifier in item.modifiers" :key="`item-${item.item_number}-modifiers--${modifier}`">
                  {{modifier}}
                </div>
                <div class="pl-1 orange--text" v-for="instruction in item.instructions" :key="`item-${item.item_number}-instructions--${instruction}`">
                  -> {{instruction}}
                </div>
              </v-flex>
              <v-flex xs2 :key="`${idx}:qty`" style="text-align: right">
                {{ item.quantity }}
              </v-flex>
            </template>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "NotificationCard",
  props: {
    message: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    closeNotify(message) {
      console.log("close message:", { message });
      this.$store.commit("deleteNotification", message.id);
    },
  },
  computed: {
    showStoreName() {
      return this.$store.getters.showStoreName;
    }
  }
};
</script>

<style>
.notification {
  border-left: 5px solid;
}
.notification .close-icon {
  position: absolute;
  right: 10px;
  top: 10px;
}
.notification:hover {
  box-shadow: 0px 6px 6px -3px rgb(0 0 0 / 20%),
    0px 10px 14px 1px rgb(0 0 0 / 14%), 0px 4px 18px 3px rgb(0 0 0 / 12%);
}
</style>